import type { FormTourConfig } from './formTour';

export const shareBookingLinkTour = {
  taskId: 'share_booking_link',
  storageKey: 'onboarding-share-booking-link-tour-step',
  startPath: '/calendars',
  activePathPrefix: '/calendars',
  navStepCount: 1,
  overlineLabel: 'Share Booking Link Tour',
  steps: [
    {
      title: 'Open Calendars',
      description: 'Click Calendars in the sidebar to open your calendar.',
      targetTestIds: ['@sidebar-calendars'],
    },
    {
      title: 'Open Booking Link',
      description: 'Click Booking Link to get a link you can share with a candidate.',
      targetTestIds: ['@booking-link-open'],
      closeTargetTestIdsOnBack: ['@booking-link-modal'],
    },
    {
      title: 'Copy the booking link',
      description: 'Copy the URL (Copy URL button or the copy icon) to share it with a candidate.',
      targetTestIds: ['@booking-link-copy-url', '@booking-link-copy'],
      highlightTargetTestIds: ['@booking-link-copy-url', '@booking-link-copy'],
      contextTargetTestIds: ['@booking-link-modal'],
      panelPlacement: 'above',
      closeTargetTestIdsOnBack: ['@booking-link-modal'],
      completeWhenTargetClicked: ['@booking-link-copy-url', '@booking-link-copy'],
    },
  ],
  stepActions: {
    0: {
      type: 'wait-for-target',
      advanceTo: 1,
      waitForTargetTestIds: ['@booking-link-open'],
    },
    1: {
      type: 'wait-for-target',
      advanceTo: 2,
      waitForTargetTestIds: ['@booking-link-modal'],
    },
    2: { type: 'complete' },
  },
} as const satisfies FormTourConfig;
